import { DOMHelper } from '../../Helpers/DOMHelper.js';

export class Popup {

	/**
	 * stepper config
	 * @param  FrontApp app      parent to access all other objects in the project
	 * @param  String elementId  dom element ID that shows up the popup on click
	 */
	constructor(app, elementId){
		this.app = app;		
		this.parentId = app.config.elementId;
		this.triggerElementId = elementId;
		this.triggerElement = document.querySelector(this.app.getSelector("#" + this.triggerElementId));		

		this.contentElementId = this.triggerElement.dataset['targetid'];

		//FOR CONTENT ELEMENT U SING APP SELECTOR BECAUSE IT ISN'T INSIDE THE LINK
		this.contentElement = document.querySelector(this.getSelector(""));
	}


	addHtml(){		
		let originalContent = this.contentElement.innerHTML;

		let newContent = `
		<div class="pm-drs-popup">
			<div class="popup-header"> ` 
			+ "<span>" + this.triggerElement.dataset['title'] + "</span>"
			+ `<hr>`
			+ `<span class="drs-close-popup-btn">x</span>`
			+ `</div>
			<div class="popup-original-content">
				`+ originalContent +`
			</div>
		</div>
		`;

		this.contentElement.innerHTML = newContent;				
	}

	init() {
		this.addHtml();
		this.addHandlers();		
	}
	
	addHandlers(){
		let thisPopup = this;

		DOMHelper.addHandler(this.getSelector(".drs-close-popup-btn"), 'click', function (){	
			thisPopup.hide();
		});

		// console.log(this.triggerElement.nodeName);
		DOMHelper.addHandler(this.triggerElement, 'click', function (event){	
			// console.log(event);
			event.preventDefault()			
			thisPopup.show(event);
		});

	}

	show(event){		
		let x = event.layerX;
		let y = event.layerY;
		this.contentElement.classList.add('show');//this first to get popup height				

		//FIX TOP
		let popupHeight = this.contentElement.offsetHeight;
		if((popupHeight + event.clientY) > document.documentElement.clientHeight){
			y = y - popupHeight;
		}
		this.contentElement.style.left = x + "px";		
		this.contentElement.style.top = y + "px";				
	}

	hide(){
		this.contentElement.classList.remove('show');
	}

	getSelector(selector) {
		return this.app.getSelector("#"+this.contentElementId + " " + selector);
	}
}